import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../../../constants';
import { channels, events, recommendedArtists } from '../../../test.data';
import { convertDateToX } from '../../../utils/common.util';
import AddArtistButton from '../../button/add-artist.button';
import ChannelCard from '../../cards/v2/channel.card';
import EventsCard from '../../cards/v2/event.card';
import HorizontalBar from '../../horizontalBar';
import { HStack, VStack } from '../../layouts/stack.layout';
import {
  CHANNELS_TAB_OPTIONS,
  EVENT_TAB_OPTIONS,
} from '../../navigation/tabs/tab-options';
import DiscoverSection from './section.discover';

export default function RecommendedContainer() {
  const navigate = useNavigate();
  return (
    <div className="pt-5">
      <DiscoverSection title="artists to follow">
        <HStack gap="base" extensions="w-full overflow-auto items-center">
          {recommendedArtists.map((artist) => (
            <AddArtistButton
              imageSrc={artist.avatarUrl}
              name={artist.displayName}
              username={artist.username}
            />
          ))}
        </HStack>
      </DiscoverSection>
      <HorizontalBar spacing="lg" />
      <DiscoverSection
        title="trending channels"
        action={() =>
          navigate(`/${PATH.CHANNELS}?tab=${CHANNELS_TAB_OPTIONS.TRENDING}`)
        }
      >
        <VStack gap="base" extensions="w-full">
          {channels
            .filter((c) => c.hasJoined === false)
            .slice(0, 2)
            .map((c) => (
              <ChannelCard channel={c} onClick={() => {}} />
            ))}
        </VStack>
      </DiscoverSection>
      <HorizontalBar spacing="lg" />
      <DiscoverSection
        title="upcoming events"
        action={() =>
          navigate(`/${PATH.EVENTS}?tab=${EVENT_TAB_OPTIONS.COMING_SOON}`)
        }
      >
        <VStack extensions="w-full" gap="base">
          {events
            .filter(
              (event) =>
                convertDateToX(event.date, 'll') >
                parseInt(moment().endOf('month').format('x'))
            )
            .map((event) => (
              <EventsCard data={event} onClick={() => {}} />
            ))}
        </VStack>
      </DiscoverSection>
      <HorizontalBar spacing="lg" />
    </div>
  );
}
